<!--suppress XmlInvalidId, HtmlUnknownBooleanAttribute, TypeScriptUnresolvedVariable, AngularUndefinedBinding -->
<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="javascript:void(0);">
      <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
    </a></li>
    <li class="breadcrumb-item active" aria-current="page" translate><a href="/private/settings" translate>Settings</a></li>
    <li class="breadcrumb-item active" aria-current="page" translate>Bank Information</li>
    <li class="breadcrumb-item">
      <a href="https://www.youtube.com/watch?v=gfPojgjZO-Q" target="_blank">
        <svg width="15" height="15" viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg">
          <g id="Group">
            <path id="Path" fill="#06209f" stroke="none"
                  d="M 683.015686 117.331543 C 526.902344 -38.973694 273.638733 -39.129089 117.331566 116.982361 C -38.973663 273.097717 -39.130989 526.363159 116.984306 682.670349 C 273.095764 838.975586 526.36322 839.130981 682.670349 683.017639 C 838.973694 526.906128 839.130981 273.636841 683.015686 117.331543 Z M 455.850311 653.819031 C 455.850311 659.991028 450.848602 664.988892 444.68042 664.988892 L 355.321472 664.988892 C 349.15332 664.988892 344.151642 659.991028 344.151642 653.819031 L 344.151642 322.097748 C 344.151642 315.925751 349.15332 310.927887 355.321472 310.927887 L 444.68042 310.927887 C 450.848602 310.927887 455.850311 315.923828 455.850311 322.097748 L 455.850311 653.819031 Z M 400.000977 264.571594 C 364.281158 264.571594 335.218811 235.513062 335.218811 199.791382 C 335.218811 164.073486 364.279266 135.009216 400.000977 135.009216 C 435.722656 135.009216 464.783112 164.071594 464.783112 199.791382 C 464.783112 235.513062 435.718811 264.571594 400.000977 264.571594 Z"/>
          </g>
          <g id="g1"/>
        </svg>
      </a>
    </li>
  </ol>
</nav>
<div [hidden]="loading" *ngIf="myBusiness" class="account-settings-container layout-top-spacing">
  <div class="iban-content">
    <div class="scrollspy-example" data-spy="scroll" data-target="#account-settings-scroll" data-offset="-100">

      <div class="card p-3 position-relative my-5" style="max-width: 442px;color: #FEFEFE;border-radius: 20px;background: linear-gradient(242deg, #3431C8 19.28%, #AA3DFF 174.72%);box-shadow: -7px 0px 69px 0px rgba(0, 0, 0, 0.03);">
        <div class="row m-3">
          <div class="col-3 text-nowrap" translate>{{'IBAN Number' | translate}}:</div>
          <div class="col-8 mx-1" translate>{{this.myBusiness.iban}}</div>
        </div>
        <div class="row m-3">
          <div class="col-3 text-nowrap" translate>{{'Bank Name' | translate}}</div>
          <div class="col-8 mx-1" translate>{{this.myBusiness.ibanBank}}</div>
        </div>
        <div class="row m-3">
          <div class="col-3 text-nowrap" translate>{{'Beneficiary Name' | translate}}</div>
          <div class="col-8 mx-1" translate>{{this.myBusiness.licenseName}}</div>
        </div>
        <div class="triangle-up">
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex flex-row my-5">
    <div>
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_165_4992)">
          <path d="M9 12V9M9 6H9.0075M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z" stroke="#3431C8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0_165_4992">
            <rect width="18" height="18" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </div>
    <div class="mx-2" style="color: #4A4A4A">{{'To change or modify bank information, please click Request Update Account from the Settings Menu Page.'|translate}}</div>
  </div>

  <button *ngIf="!submitting && (isMerchant || isManager)" class="btn btn-primary" translate (click)="close()">Close</button>

</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
